"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Utils = _interopRequireWildcard(require("@financial-times/o-utils"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _debug;
/**
 *
 * @param {string} eventType
 * @param {object} data
 * @param {EventTarget} target
 */


function broadcast(eventType, data, target) {
  target = target || document.body;

  if (_debug) {
    console.log('o-viewport', eventType, data);
  }

  target.dispatchEvent(new CustomEvent('oViewport.' + eventType, {
    detail: data,
    bubbles: true
  }));
}
/**
* Get the viewport height.
* @param {boolean} ignoreScrollbars [false] - set to true to discount scrollbar height.
* @return {number}
*/


function getHeight(ignoreScrollbars) {
  return ignoreScrollbars ? document.documentElement.clientHeight : Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
}
/**
* Get the viewport width.
* @param {boolean} ignoreScrollbars [false] - set to true to discount scrollbar width
* @return {number}
*/


function getWidth(ignoreScrollbars) {
  return ignoreScrollbars ? document.documentElement.clientWidth : Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}
/**
 * Viewport size.
 * @typedef {Object} Size
 * @property {number} height
 * @property {number} width
 */

/**
* Get the viewport width and height.
* @param {boolean} ignoreScrollbars [false] - set to true to discount scrollbar width/height.
* @return {Size}
*/


function getSize(ignoreScrollbars) {
  return {
    height: getHeight(ignoreScrollbars),
    width: getWidth(ignoreScrollbars)
  };
}
/**
 * Scroll position.
 * @typedef {Object} ScrollPosition
 * @property {number} height - `document.body.scrollHeight`
 * @property {number} width - `document.body.scrollWidth`
 * @property {number} left - `window.pageXOffset || window.scrollX`
 * @property {number} top - `window.pageYOffset || window.scrollY`
 */

/**
 * @return {ScrollPosition}
 */


function getScrollPosition() {
  return {
    height: document.body.scrollHeight,
    width: document.body.scrollWidth,
    left: window.pageXOffset || window.scrollX,
    top: window.pageYOffset || window.scrollY
  };
}
/**
 * @return {string} - 'portrait' or 'landscape'
 */


function getOrientation() {
  var orientation = window.screen.orientation;

  if (orientation) {
    return typeof orientation === 'string' ? orientation.split('-')[0] : orientation.type.split('-')[0];
  } else if (window.matchMedia) {
    return window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
  } else {
    return getHeight() >= getWidth() ? 'portrait' : 'landscape';
  }
}
/**
 * @return {boolean} - true if the viewport is visible
 */


function getVisibility() {
  return document.hidden;
}

var _default = {
  debug: function debug() {
    _debug = true;
  },
  broadcast,
  getWidth,
  getHeight,
  getSize,
  getScrollPosition,
  getVisibility,
  getOrientation,
  debounce: Utils.debounce,
  throttle: Utils.throttle
};
exports.default = _default;
module.exports = exports.default;